import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import config from 'appconfig';

const link = new HttpLink({
  uri: config.omniChannelGraphQLUrl,
  credentials: 'include',
});

export const omniChannelApolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});
